import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_flex _px-2 _py-3 _jc-sb _ai-c _bxsh--base" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon_link = _resolveComponent("icon-link")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createVNode(_component_icon_link, {
      class: "_tc--accent",
      icon: "times",
      as: "button",
      onClick: _ctx.onClose
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.Resources.Common.ModalCloseButton), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onClick"])
  ]))
}